import * as yup from 'yup';
import { TFunction } from 'i18next';
import { FormFieldDto, FormFieldType, FormItemDto, FormItemKind } from '../document-generation.dto';

export function mapFormSchemaToYupSchema(items: FormItemDto[], t: TFunction) {
    const fields = items.filter((item) => item.kind === FormItemKind.FIELD) as FormFieldDto[];
    const shape = fields.reduce(
        (acc, field) => {
            const { key, type, config } = field;

            let validator = null;

            switch (type) {
                case FormFieldType.TEXT:
                    validator = yup.string();
                    if (config.validation?.minLength)
                        validator = validator.min(
                            config.validation.minLength,
                            t('Minimum {{count}} characters', { count: config.validation.minLength }),
                        );
                    if (config.validation?.maxLength)
                        validator = validator.max(
                            config.validation.maxLength,
                            t('Maximum {{count}} characters', { count: config.validation.maxLength }),
                        );
                    break;

                case FormFieldType.NUMBER:
                    validator = yup.number();
                    if (config.validation?.minValue)
                        validator = validator.min(
                            config.validation.minValue,
                            t('Minimum value is {{value}}', { value: config.validation.minValue }),
                        );
                    if (config.validation?.maxValue)
                        validator = validator.max(
                            config.validation.maxValue,
                            t('Maximum value is {{value}}', { value: config.validation.maxValue }),
                        );
                    break;

                default:
                    validator = yup.mixed();
            }

            if (config.required) {
                validator = validator.required(t('This field is required'));
            }

            acc[key] = validator;
            return acc;
        },
        {} as Record<string, yup.AnySchema>,
    );

    return yup.object().shape(shape);
}
